
export const FORM_REQUISITION = "requisition"
export const FORM_LOGIN = "login"
export const JWT = "jwt"
export const AWS_PINPOINT_APP_ID = "0b9f76844e36443da2800b402babe660"
export const IDENTITY_POOL_ID = "us-east-1:3c693e30-06c6-4da4-9133-7239d0587c41"

export const JOB_CATEGORY = [
    "Accounting and Finance",
    "Agriculture, Farming and Conservation",
    "Audit and Compliance",
    "Administration and Office Support",
    "Advertising, Arts and Media",
    "Business Development",
    "Customer Service",
    "Construction, Design, Architecture and Engineering",
    "Education and Training",
    "Food and Beverage",
    "Governance",
    "Healthcare and Medical",
    "Hospitality and Tourism",
    "Human Resources and Recruitment",
    "Information Technology",
    "Legal",
    "Manufacturing, Transport and Logistics",
    "Marketing and Communications",
    "Mining, Resources and Energy",
    "Supply Chain Management, Procurement and Purchasing",
    "Trade and Services",
    "Others"
]
export const BENEFITS = [
    "Transportation",
    "Medical Insurance",
    "Accommodation",
    "Meal Allowance"
]

export const CURRENCY_TYPE = ["MMK", "USD"]

export const CONTRACT = [
    {name: "Full Time", value:"full"},
    {name: "Part Time", value:"part"},
    {name: "Fixed Term", value:"fixed"}
]